import axios from 'axios'
import qs from 'qs'
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from '../../urlLink'
import {isGraySchoolEnabled} from "@/bootstrap/graySchoolRouting";
const root = Urls.crmApiUrl //域名
//首页数据请求
const url = {
  getCourseType: `${root}/CrmStudent/getCourseType`,
  getClientinvite: root + "/Clientinvite/Home",
  getClientinviteExport: root + "/Clientinvite/Home/Export",
  getAudition: root + "/Clientinvite/audition",
  getAuditionExport: root + "/Clientinvite/audition/Export",
  postIsvisit: root + "/Clientinvite/isvisitApi",
  getMarketer: root + "/Public/getMarketerApi",
  getIsvisterReason: root + "/Public/getIsvisterReasonApi",
  postIsaudition: root + "/Clientinvite/isauditionApi",
  getSchoolClass: root + "/Public/getSchoolClassApi",
  getFriendRelation: root + "/Public/getFriendRelationApi",
  getClientName: root + "/Client/getClientNameApi",
  bindingClient: root + "/Client/bindingClientAction",
  settingtrackClient: root + "/Clientinvite/inviteTrackApi",
  getCrmStudentOneApi: `${root}/CrmStudent/getCrmStudentOneApi`, // 二次招生->获取学生的详细信息-lujing
  getAuditionTypesApi: root + "/Intentionclient/getAuditionTypesApi",
  isMarketerClientPrincipal: root + "/Clientinvite/isMarketerClientPrincipal",

};
const storeInvitationauditionmanage = {
  //柜询管理
  getClientinvite(params) {
    return axios.get(url.getClientinvite, {
      params
    })
  },
  getCourseType(params) {
    return axios.get(url.getCourseType, {
      params
    })
  },
  //柜询管理---导出
  getClientinvite1(){
    return isGraySchoolEnabled() ? url.getClientinviteExport: url.getClientinvite
  },
  //试听管理
  getAudition(params) {
    return axios.get(url.getAudition, {
      params
    })
  },
  //试听管理---导出
  getAudition1(){
    return isGraySchoolEnabled() ? url.getAuditionExport: url.getAudition
  },
  // 获取招生的负责人
  getMarketer(params) {
    return axios.get(url.getMarketer, {
      params
    })
  },
  // 获取未到访原因模板
  getIsvisterReason(params) {
    return axios.get(url.getIsvisterReason, {
      params
    })
  },
  // 获取学校的班级
  getSchoolClass(params) {
    return axios.get(url.getSchoolClass, {
      params
    })
  },
  //试听管理->设置试听状态 
  postIsaudition(params) {
    return axios.post(url.postIsaudition, qs.stringify(params))
  },
  // 柜询管理->设置到访或未到访
  postIsvisit(params) {
    return axios.post(url.postIsvisit, qs.stringify(params))
  },
  // 获取绑定关系
  getFriendRelation(params) {
    return axios.get(url.getFriendRelation, {
      params
    })
  },
  // 绑定学员->获取人员名称
  getClientName(params) {
    return axios.get(url.getClientName, {
      params
    })
  },
  // 招生目标线索->绑定学员
  bindingClient(params) {
    return axios.post(url.bindingClient, qs.stringify(params))
  },
  // 招生目标线索->跟进客户
  settingtrackClient(params) {
    return axios.post(url.settingtrackClient, qs.stringify(params))
  },
  getCrmStudentOneApi(params) {
    return axios.get(url.getCrmStudentOneApi, {
      params,
    });
  },
  getAuditionTypesApi(params) {
    return axios.get(url.getAuditionTypesApi, {
      params,
    });
  },
  isMarketerClientPrincipal(params) {
    return axios.get(url.isMarketerClientPrincipal, {
      params,
    });
  },
}

export default storeInvitationauditionmanage;